<template>
    <div>
        <div :class="{'dropdown-content dropdown-content-padded': !inline}">
            <p :class="{'stack-xs': inline}">There are 2 exclusive values for: {{filter.label}}</p>
        </div>
        <div :class="{'dropdown-content dropdown-content-padded': !inline}">
            <v-radio
                label="True"
                :group="groupId"
                :value="true"
                class="stack-s"
                :model="initialValue"
                @update="updateValue"
            />
            <v-radio
                label="False"
                :group="groupId"
                :model="initialValue"
                :value="false"
                @update="updateValue"
            />
        </div>
        <slot v-if="$slots.footer" name="footer"/>
        <filter-footer v-else @update="updateFilter"/>
    </div>
</template>

<script>
    import vIcon from '@/components/form/v-icon';
    import vRadio from '@/components/form/v-radio';
    import filterMixins from './filter-mixins';
    import FilterFooter from './filter-footer';
    import shortid from 'shortid';

    export default {
        mixins: [filterMixins],
        components: {vIcon, vRadio, FilterFooter},
        computed: {
            initialValue() {
                return this.adapter.getInitialFilterValue(this.filter);
            },
            groupId() {
                return shortid.generate();
            },
        },
        data() {
            return {
                value: null,
            };
        },
        methods: {
            makePayload() {
                return this.adapter.getFilterPayload({
                    index: this.index,
                    filter: this.filter,
                    assign: {value: this.value},
                });
            },
            updateValue(value) {
                this.value = value;
                if (this.inline) {
                    this.$nextTick(() => {
                        const payload = this.makePayload();
                        this.$emit('input', payload);
                    });
                }
            },
            updateFilter() {
                const payload = this.makePayload();
                this.$emit('update', payload);
                this.$parent.$emit('request-popper-hide');
            },
        },
        mounted() {
            this.value = this.initialValue;
        },
    };
</script>
